import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  list: [],
  filter: ''
}

// mutations
export const mutations = {
  [types.SET_LIST] (state, obj) {
    state.list = obj.query
  },
  [types.SET_FILTER] (state, obj) {
    state.filter = obj === 'TODOS' ? '' : obj
  }
}

// actions
export const actions = {
  async fetchTematic ({ commit }) {
    try {
      const { data } = await axios.get('/api/agremiado/getUserTematic')
      commit(types.SET_LIST, data) // enviamos data a la mutation set list
    } catch (e) {
      // commit(types.FETCH_EVENTS_FAILURE)
    }
  },
  async setFilter ({ commit }, filter) {
    commit(types.SET_FILTER, filter)
  }
}

// getters
export const getters = {
  getTematicList: state => state.list,
  getTematicListFilter: state => state.filter
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/tematic.js